import { render, staticRenderFns } from "./collectlist.vue?vue&type=template&id=3026f0b2"
import script from "./collectlist.vue?vue&type=script&lang=js"
export * from "./collectlist.vue?vue&type=script&lang=js"
import style0 from "./collectlist.vue?vue&type=style&index=0&id=3026f0b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports